import Form from "antd/lib/form";
import Modal from "antd/lib/modal";
import notification from "antd/lib/notification";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getImageBaseUrl } from "../services/s3-utils";
import { sendEmail } from "../services/NewServices";
import { LoadingOutlined } from "@ant-design/icons";

function ShareUrl({
  title,
  visible,
  onCancel,
  setShareModalVisible,
  url,
  cohortName,
}) {
  const [loading, setLoading] = useState(false);
  const [val, setVal] = useState("");
  const pageUrl = url || `${window.location.href}`;

  const handleEmail = async () => {
    if (!val) {
      notification.error({
        description: "Please enter email",
      });
      return;
    }
    let data = {
      recipient: val,
      link: pageUrl,
    };
    if (title === "Cohort") {
      data["cohort_name"] = cohortName;
    }
    setLoading(true);
    try {
      await sendEmail(data, title);
      notification.success({
        description: "Email sent successfully",
      });
      setVal("");
    } catch (error) {
      notification.error({
        description: error.response?.data?.message || "An error occured",
      });
    } finally {
      setLoading(false);
      setShareModalVisible(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        title={`Share ${title}`}
        footer={null}
        onCancel={onCancel}
      >
        <img src={`${getImageBaseUrl}/assets/share-banner.svg`} alt="" />

        {/* <p className="text-main font-medium mt-10 p-xs ">Socials</p>
        <div className="flex gap-2">
          <div className="flex flex-col">
            <img src={`${getImageBaseUrl}/assets/social-chat.svg`} alt="" />
            <p className="text-center text-xs mt-2 text-main">Chat</p>
          </div>
          <div className="flex flex-col">
            <img src={`${getImageBaseUrl}/assets/social-telegram.svg`} alt="" />
            <p className="text-center text-xs mt-2 text-main">Telegram</p>
          </div>
          <div className="flex flex-col">
            <img src={`${getImageBaseUrl}/assets/social-twitter.svg`} alt="" />
            <p className="text-center text-xs mt-2 text-main">Twitter</p>
          </div>
          <div className="flex flex-col">
            <img src={`${getImageBaseUrl}/assets/social-whatsapp.svg`} alt="" />
            <p className="text-center text-xs mt-2 text-main">Whatsapp</p>
          </div>
          <div className="flex flex-col">
            <img src={`${getImageBaseUrl}/assets/social-email.svg`} alt="" />
            <p className="text-center text-xs mt-2 text-main">Email</p>
          </div>
          <div className="flex flex-col">
            <img src={`${getImageBaseUrl}/assets/social-more.svg`} alt="" />
            <p className="text-center text-xs mt-2 text-main">More</p>
          </div>
        </div> */}
        <p className="text-main mt-10 mb-2 p-xs font-medium">Copy link</p>
        <div className="bg-pri-tint-3 flex px-4 py-3 rounded-md justify-between">
          <span className="pri whitespace-nowrap overflow-hidden overflow-ellipsis mr-4">
            {pageUrl}
          </span>

          <CopyToClipboard
            text={pageUrl}
            onCopy={() =>
              notification.success({
                description: `${title} link copied!`,
              })
            }
          >
            <img
              src={`${getImageBaseUrl}/assets/copy-pri.svg`}
              alt=""
              className="pointer"
            />
          </CopyToClipboard>
        </div>
        <p className="text-main font-medium mt-[26px] p-xs mb-0.5">
          Email Address
        </p>
        <div className="relative">
          <Form.Item
            name="email"
            className="!mb-0"
            rules={[
              {
                required: true,
                message: "Please input your Email address!",
              },
            ]}
          >
            <input
              value={val}
              onChange={(e) => setVal(e.target.value)}
              className="main-input rounded-md w-full focus:outline-none px-5 py-4"
            />
          </Form.Item>
          <button
            onClick={handleEmail}
            style={{
              backgroundColor: "red",
            }}
          >
            {loading ? (
              <span className="absolute w-5 h-5 top-[14px] right-4">
                <LoadingOutlined />
              </span>
            ) : (
              <img
                src={`${getImageBaseUrl}/assets/paper-plane.svg`}
                alt=""
                className="absolute w-5 h-5 top-[18px] right-4"
              />
            )}
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ShareUrl;
